import Event from '../models/Event';
import TicketType from '../models/TicketType';

export interface VatRate {
    key: string,
    rate: number
}

class VatRepository {
    private rates: Array<VatRate> = [
        {
            key: 'uk_standard',
            rate: 0.2
        },
        { //10% GST/VAT for Aus
            key: 'aus_standard',
            rate: 0.1
        },
        {
            key: 'uk_reduced_125',
            rate: 0.125
        },
        {
            key: 'uk_reduced',
            rate: 0.05
        },
        {
            key: 'uk_zero',
            rate: 0
        },
        {
            key: 'aus_zero',
            rate: 0
        }
    ];

    /**
     * @return {string}
     */
    get DEFAULT_RATE():string {
        return 'uk_standard';
    }

    /**
     * @param {Event} event
     * @param {TicketType} ticketType
     * @return {number}
     */
    getByTicketType(event: Event, ticketType: TicketType): number {
        const key = ticketType.customer_vat_rate || event.ticket_type_vat_rate || this.DEFAULT_RATE;

        return this.getRateByKey(key).rate;
    }

    /**
     * @param {string} key
     * @return {VatRate}
     */
    private getRateByKey(key:string):VatRate {
        const matches = this.rates.filter((rate: VatRate) => rate.key === key);

        return matches.length ? matches[0] : this.getRateByKey(this.DEFAULT_RATE);
    }
}

export default new VatRepository();
